import PageContainer from "../common/PageContainer";
import Header from "../common/Header";
import RouteProtection from "../common/RouteProtection";
import PasswordInput from "./PasswordInput";
import TopLine from "../common/TopLine";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import uniqid from "uniqid";
import { fetchWithToken } from "../../functions/fetch";
import SuccessPopUp from "./SuccessPopUp";

const UpdatePasswordPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confNewPassword, setConfNewPassword] = useState("");
  const [errorMessages, setErrorMessages] = useState([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const navigate = useNavigate();

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const submit = async () => {
    const currentUser = JSON.parse(window.sessionStorage.getItem("user"));
    const formBody = {
      oldPassword,
      newPassword,
    };

    const res = await fetchWithToken(
      "PUT",
      `${process.env.REACT_APP_BACKEND_HOST}/api/admin/${currentUser.adminId}`,
      formBody,
    );

    if (res.status === 200) {
      setShowPopUp(true);
    } else if (res.status === 400) {
      let newErrorMessages = [];
      if (res.msg) {
        newErrorMessages.push(res.msg);
      } else if (res.errors) {
        newErrorMessages = res.errors.map((error) => error.msg);
      }

      setErrorMessages(newErrorMessages);
    } else {
      console.error(`Unknown response status: ${res.status}`);
    }
  };

  const cancel = () => {
    navigate("/");
  };

  useEffect(() => {
    const newMessages = [];
    if (newPassword.length < 5) {
      newMessages.push("新密碼長度應至少五位");
    }
    if (confNewPassword !== newPassword) {
      newMessages.push("確認新密碼與新密碼不合");
    }

    setErrorMessages(newMessages);
  }, [oldPassword, newPassword, confNewPassword]);

  return (
    <>
      <RouteProtection />
      <Header />
      {showPopUp ? <SuccessPopUp setShowPopUp={setShowPopUp} /> : <></>}
      <PageContainer>
        <div className="pl-12 py-8 grid overflow-y-auto auto-rows-min gap-y-2 w-[60%]">
          <h1 className="font-chinese text-2xl text-custom-gray font-bold mb-2">
            修改密碼
          </h1>
          <TopLine />
          <label
            htmlFor="oldPassword"
            className="font-chinese text-xl text-custom-gray"
          >
            目前密碼
          </label>
          <PasswordInput
            id="oldPassword"
            showPassword={showPassword}
            setFunction={setOldPassword}
            placeholder="請輸入目前密碼"
          />
          <label
            htmlFor="newPassword"
            className=" font-chinese text-xl text-custom-gray"
          >
            新密碼
          </label>
          <PasswordInput
            id="newPassword"
            showPassword={showPassword}
            setFunction={setNewPassword}
            placeholder="請輸入新密碼"
          />
          <label className="font-chinese text-xl text-custom-gray">
            確認新密碼
          </label>
          <PasswordInput
            id="confNewPassword"
            showPassword={showPassword}
            setFunction={setConfNewPassword}
            placeholder="請再次輸入新密碼"
          />
          <div className="flex gap-x-2 items-center mt-4">
            <input
              id="showPassword"
              onClick={togglePassword}
              type="checkbox"
              className="w-6 h-6"
            />
            <label
              htmlFor="showPassword"
              className="font-chinese text-xl text-custom-gray"
            >
              顯示密碼
            </label>
          </div>
          <ul>
            {errorMessages.map((message) => (
              <li key={uniqid()} className="text-custom-red font-chinese">
                {message}
              </li>
            ))}
          </ul>
          <div className="absolute bottom-4 right-24 flex gap-x-2">
            <button
              onClick={submit}
              disabled={errorMessages.length > 0}
              className={`w-20 h-12 border-2 rounded border-custom-orange bg-custom-orange font-chinese text-white
              ${errorMessages.length > 0 ? "" : "hover:brightness-75"}
               disabled:bg-custom-gray disabled:border-custom-gray`}
            >
              送出
            </button>
            <button
              onClick={cancel}
              className="w-20 h-12 border-2 rounded border-border-gray font-chinese text-custom-gray hover:bg-custom-gray hover:text-white"
            >
              取消
            </button>
          </div>
        </div>
      </PageContainer>
    </>
  );
};

export default UpdatePasswordPage;
